import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { APP_IMPORTS } from './app.imports';
import { APP_PROVIDERS } from './app.providers';
import { EnvironmentModule } from './environment/environment.module';
import { CurrencyPipe } from '@angular/common';
import { SharedModule } from './shared/shared.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiKeyInterceptor } from 'src/lib/angular/service/interceptor/api.interceptor';
import { InitializeScriptService } from './services/api/InitializeScript.service';
export function initApp(initService: any) {
  return () => initService.getApiToken();
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    APP_IMPORTS,
    BrowserModule,
    EnvironmentModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: false
    , connectInZone: true}),
    SharedModule
  ],
  providers: [
    APP_PROVIDERS,
    CurrencyPipe,
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [InitializeScriptService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiKeyInterceptor,
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
